import { useResolvedPath } from 'react-router-dom';
import { Tab } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { useDeviceType } from '../../../../utilities/common/deviceType';

interface IFilterSidebarProps {
  sidebarItems: {
    label: string;
    numberOfSelected: number;
    key: string;
  }[];
  showOrgs?: boolean;
  showRegion?: boolean;
  showDept?: boolean;
}

export default function FilterSidebar({
  sidebarItems,
  showOrgs,
  showRegion,
  showDept,
}: IFilterSidebarProps) {
  const isMobile = useDeviceType();
  const { t } = useTranslation();

  const renderCondition = (item: any) =>
    (useResolvedPath('.').pathname === '/reports' &&
      item.key !== 'filter_org') ||
    (!showOrgs && item.key === 'filter_org') ||
    (!showRegion && item.key === 'filter_region') ||
    (!showDept && item.key === 'filter_department');

  const numOfSelectedFilter = (item: any) =>
    item.numberOfSelected > 0 && (
      <span className="rounded-full bg-blue-700 px-2 py-0.5 text-xs font-semibold text-white">
        {item.numberOfSelected}
      </span>
    );

  const renderMobileItems = () => {
    return sidebarItems.map((item) =>
      renderCondition(item) ? null : (
        <div
          key={`sidebar-item-${item.label}`}
          className="text-grey-700 px-[14px] py-4 font-semibold transition-all duration-75 hover:bg-blue-50 hover:font-semibold focus:bg-blue-50"
        >
          <div className="flex items-center gap-4">
            <>
              {t(item.label)}
              {numOfSelectedFilter(item)}
            </>
          </div>
        </div>
      ),
    );
  };

  const renderDesktopItems = () => {
    return sidebarItems.map((item) =>
      renderCondition(item) ? null : (
        <Tab
          key={`sidebar-item-${item.label}`}
          className={({ selected }) =>
            `${
              selected && 'bg-blue-50 font-medium !text-blue-700'
            } [&>.chevron]focus:outline-hidden group text-grey-700 flex cursor-pointer items-center gap-x-2 rounded-lg px-[14px] py-4 text-left font-medium transition-all duration-75 hover:bg-blue-50 focus:bg-blue-50`
          }
        >
          <div className="flex items-center gap-4 capitalize">
            {t(item.label)}
          </div>
          {numOfSelectedFilter(item)}
        </Tab>
      ),
    );
  };

  return isMobile ? (
    <>{renderMobileItems()}</>
  ) : (
    <div className="col-span-1 flex h-[65vh] flex-col gap-y-1 pt-[17px] pr-[17px] text-left">
      {renderDesktopItems()}
    </div>
  );
}
